import React, {useState} from "react";
import {Col, Modal, Row} from "react-bootstrap";
import {disclaimerBoldTextStyles, disclaimerTextStyles, subHeadingStyles} from "../Style";

function DisclaimerPopup(props) {
    const [enableButton, setEnableButton] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleClose = () => {
        props.setParentDeclarationPopupShow(false);
    };
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
    ? 'carAutosureEvent'
    : window.location.href.includes('quashed')
      ? 'carQuashedEvent'
      : window.location.href.includes('better')
        ? 'carBetterEvent'
        : window.location.href.includes('simplify')
          ? 'carSimplifyEvent'
          : '';
    const handleCloseAndNext = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': `${eventName}`,
          'category': 'Important Information Consent',
          'virtualUrl': `${baseUrl}/vehicle/step1`,
          'pageTitle': 'Car',
        });
      props.setParentDeclarationPopupShow(false);
        props.handleChangeValue('showDisclaimer', false);
    };
    return (<span style={{fontSize: "10px"}}>
      <Modal
        style={{paddingTop: "90px"}}
          show={props.parentDeclarationPopupShow}
          onHide={handleClose}
          backdrop="static"
          size="lg"
          keyboard={false}
      >
        {/*<Modal.Header closeButton style={{background: "#E5E7EB"}}>*/}
          {/*  <Modal.Title style={subHeadingStyles}>*/}
          {/*    {" "}*/}
          {/*      Disclosure and declaration*/}
          {/*  </Modal.Title>*/}
          {/*</Modal.Header>*/}

          <Modal.Body style={{background: "white"}}>
          <div style={disclaimerTextStyles}>
            <div style={{...subHeadingStyles}}>Important information</div>
            <div style={{paddingTop: "10px"}}>
                <div style={disclaimerBoldTextStyles}>
                    <b> Insurance quote</b>
                    <p style={disclaimerTextStyles}>Online quotes and insurance are provided by Vero Insurance New Zealand Limited (Vero).</p>
                </div>
            </div>
            <div style={{...disclaimerBoldTextStyles}}><b>Duty of disclosure</b></div>
            <div style={{...disclaimerTextStyles, paddingBottom: "15px"}}>Vero's decision to insure you is based on the
                information you provide. This
                includes the terms that
                are applied and the premium that is charged. It is very important that your answers to questions are
                correct and complete. If they are not, you may not have cover if you have a claim. Your policy might
                also be avoided, which means it is treated as if it never existed. This could make it difficult to
                get insurance in the future.
                <div style={{paddingTop: "10px"}}>By requesting a quote from us, you accept our <a
                href="https://www.vero.co.nz/terms-of-use/carinsurance.html" target="_blank" rel="noopener noreferrer"
                style={{color: "black"}}>quote terms
                  and conditions</a>.</div>
            </div>
            <div style={{...disclaimerBoldTextStyles}}><b>No financial advice</b></div>
            <div style={{...disclaimerTextStyles}}>
                <div>This tool is designed to assist you to obtain a quote and purchase insurance cover from Vero.</div>
                <div>Neither Vero, nor Autosure are providing you with financial advice or a recommendation on
                    which
                    product is best suited to your needs or how much cover to take out. Any estimates are for
                    information only and based on information you supply or may come from generic third party data that
                    does not take into account all your specific circumstances. This is not financial advice and you
                    should carefully consider any estimates against your insurance needs.</div>
              <br/>
                <div>By using this tool, you agree that it is your responsibility to set the amount covered and choose the
                    cover options you require.</div>
            </div>
            <Row>
              <Col>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingTop: "15px",
                    }}
                >
                  <button
                      style={{
                          color: "white",
                          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                          borderRadius: 6,
                          paddingLeft: 25,
                          paddingRight: 25,
                          paddingTop: 13,
                          paddingBottom: 13,
                          overflow: "hidden",
                          border: "1px white solid",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "inline-flex",
                          width: "100%",
                          maxWidth: "200px",
                          background: "#1851A3",
                          cursor: "pointer",
                      }}
                      onClick={handleCloseAndNext}
                      className="float-left"
                  >
                    I understand
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </span>
    );
}

export default DisclaimerPopup;
